import axios from "axios";
import { encryptAuthData } from "components/encryptionHandler";

const { REACT_APP_BASE_URL, REACT_APP_OMS_AUTH_USERNAME, REACT_APP_OMS_AUTH_PASSWORD } = process.env;

export const AuthHeader = () => {
    const credentials = `${REACT_APP_OMS_AUTH_USERNAME}:${REACT_APP_OMS_AUTH_PASSWORD}`;
    const encAuthString = encryptAuthData(credentials);
    return {
        "Authorization": `Basic ${encAuthString}`
    }
}

const setupAxios = (headers = null) => {
    const baseUrl = REACT_APP_BASE_URL;
    const instance = axios.create({
        baseUrl,
        // withCredentials: true
    });
    instance.interceptors.request.use((config) => {
        const customConfig = config;
        customConfig.baseURL = baseUrl;
        const baseHeader = {
            // "Ocp-Apim-Subscription-Key": REACT_APP_OCP_APIM_KEY,
        }
        if (headers) {
            customConfig.headers = {
                ...headers,
                ...baseHeader
            }
        } else {
            customConfig.headers = baseHeader
        }

        return customConfig;
    });
    // Intercept the response and handle errors
    instance.interceptors.response.use(
        (response) => {
            return response;
        },
        (error) => {
            if (error?.response?.status === 401) {
                console.log("auth failed");
            } else {
                return Promise.reject(error);
            }
        }
    );
    return instance;
}
export default setupAxios;
